import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionPostBookingSurveySection } from "./post-booking-survey-section";

import type { HotelPolicyCategoriesAndManagerStore } from "../../../../store/categories";

type Props = {
	postBookingSurveySettings: HotelPolicyCategoriesAndManagerStore["postBookingSurveySettings"];
};

export const QuestionPostBookingSurveySettings = ({ postBookingSurveySettings }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={postBookingSurveySettings}>
			<QuestionPostBookingSurveySection />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionPostBookingSurveySettings.displayName = "QuestionPostBookingSurveySettings";
